class CustomSlideshow {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll('.custom-slide'));
    this.dotsContainers = Array.from(element.querySelectorAll('.custom-slideshow-dots'));
    this.prevButton = element.querySelector('.custom-slideshow-arrow--prev');
    this.nextButton = element.querySelector('.custom-slideshow-arrow--next');
    this.currentSlide = 0;
    this.autoplay = element.dataset.autoplay === 'true';
    this.autoplayInterval = parseInt(element.dataset.autoplayInterval) * 1000 || 3000;
    this.autoplayTimer = null;
    
    this.init();
  }
  
  init() {
 
    
    if (this.slides.length === 0) {
      return;
    }
    
    // Preload all images for immediate display
    this.preloadImages();
    
    // Set initial slide
    this.showSlide(0);
    
    // Dots functionality disabled
    // this.createDots();
    
    // Add event listeners
    this.addEventListeners();
    
    // Mark slideshow as initialized to prevent FOUC
    this.element.classList.add('slideshow--initialized');
    
    // Start autoplay if enabled and there are multiple slides
    if (this.autoplay && this.slides.length > 1) {
      // Small delay to ensure everything is loaded
      setTimeout(() => {
        this.startAutoplay();
      }, 100);
    }
  }
  
  preloadImages() {
    // Get all images in the slideshow
    const images = this.element.querySelectorAll('img');
    
    images.forEach(img => {
      // Set opacity to 1 when image loads
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.addEventListener('load', () => {
          img.style.opacity = '1';
        });
        
        // Handle error cases
        img.addEventListener('error', () => {
          img.style.opacity = '1'; // Still show the image even if there's an error
        });
      }
    });
  }
  
  createDots() {
    // Dots functionality disabled - slideshow works without visible dots
    // All navigation is handled through prev/next buttons, autoplay, and touch/swipe
    return;
  }
  
  addEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }
    
    // Pause autoplay on hover
    this.element.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.element.addEventListener('mouseleave', () => {
      if (this.autoplay) {
        this.startAutoplay();
      }
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (this.element.contains(document.activeElement) || this.element.matches(':hover')) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      }
    });
    
    // Touch/swipe functionality for mobile
    this.addTouchSupport();
  }
  
  showSlide(index) {

    
    if (index < 0 || index >= this.slides.length) {
      return;
    }
    
    // Remove active class from all slides
    this.slides.forEach((slide, i) => {
      slide.classList.remove('active');
    });
    
    // Add active class to current slide
    this.slides[index].classList.add('active');
    this.currentSlide = index;
    
    // this.updateDots(); // Dots disabled
  }
  
  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }
  
  prevSlide() {
    const prevIndex = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    this.showSlide(prevIndex);
  }
  
  goToSlide(index) {
    this.showSlide(index);
  }
  
  updateDots() {
    // Dots functionality disabled - no visual dots to update
    return;
  }
  
  startAutoplay() {
    if (!this.autoplay) {
      return;
    }
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
    this.autoplayTimer = setInterval(() => {
      this.nextSlide();
    }, this.autoplayInterval);
  }
  
  pauseAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
  
  addTouchSupport() {
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    let isSwiping = false;
    
    // Touch start
    this.element.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwiping = false;
    }, { passive: true });
    
    // Touch move
    this.element.addEventListener('touchmove', (e) => {
      if (!startX || !startY) return;
      
      endX = e.touches[0].clientX;
      endY = e.touches[0].clientY;
      
      const diffX = startX - endX;
      const diffY = startY - endY;
      
      // Check if it's a horizontal swipe (more horizontal than vertical)
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
        isSwiping = true;
        e.preventDefault(); // Prevent default scrolling
      }
    }, { passive: false });
    
    // Touch end
    this.element.addEventListener('touchend', (e) => {
      if (!isSwiping || !startX || !endX) return;
      
      const diffX = startX - endX;
      const minSwipeDistance = 50; // Minimum distance for a swipe
      
      if (Math.abs(diffX) > minSwipeDistance) {
        if (diffX > 0) {
          // Swiped left - go to next slide
          this.nextSlide();
        } else {
          // Swiped right - go to previous slide
          this.prevSlide();
        }
      }
      
      // Reset values
      startX = 0;
      startY = 0;
      endX = 0;
      endY = 0;
      isSwiping = false;
    }, { passive: true });
  }
}

// Initialize all custom slideshows when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('.custom-slideshow');
  slideshows.forEach(slideshow => {
    new CustomSlideshow(slideshow);
  });
});

// Handle Shopify section updates
document.addEventListener('shopify:section:load', (event) => {
  const slideshow = event.target.querySelector('.custom-slideshow');
  if (slideshow) {
    new CustomSlideshow(slideshow);
  }
}); 